import { create } from 'zustand';
import { subscribeWithSelector, persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';
import authService from '@app/service/authService';
import settingStore from '@app/stores/settingStore';
import { DEVICE_STORAGE_KEY } from '@app/stores/storageKeys';
import { isJwtExpired } from '@app/utils/jwt';
// [출처] [자바스크립트] 브라우저 이름 / 버전 값 구하기|작성자 Scripter https://blog.naver.com/tk2rush90/221093115465
function getClientInfo() {
  var userAgent = navigator.userAgent;
  var reg = null;
  var browser = {
    name: null,
    version: null,
  };

  userAgent = userAgent.toLowerCase();
  if (userAgent.indexOf('opr') !== -1) {
    reg = /opr\/(\S+)/;
    browser.name = 'Opera';
    browser.version = reg.exec(userAgent)[1];
  } else if (userAgent.indexOf('edge') !== -1) {
    reg = /edge\/(\S+)/;
    browser.name = 'Edge';
    browser.version = reg.exec(userAgent)[1];
  } else if (userAgent.indexOf('chrome') !== -1) {
    reg = /chrome\/(\S+)/;
    browser.name = 'Chrome';
    browser.version = reg.exec(userAgent)[1];
  } else if (userAgent.indexOf('safari') !== -1) {
    reg = /safari\/(\S+)/;
    browser.name = 'Safari';
    browser.version = reg.exec(userAgent)[1];
  } else if (userAgent.indexOf('firefox') !== -1) {
    reg = /firefox\/(\S+)/;
    browser.name = 'Firefox';
    browser.version = reg.exec(userAgent)[1];
  } else if (userAgent.indexOf('trident') !== -1) {
    browser.name = 'IE';
    if (userAgent.indexOf('msie') !== -1) {
      reg = /msie (\S+)/;
      browser.version = reg.exec(userAgent)[1];
      browser.version = browser.version.replace(';', '');
    } else {
      reg = /rv:(\S+)/;
      browser.version = reg.exec(userAgent)[1];
    }
  } else if (userAgent.indexOf('kakaotalk') !== -1) {
    reg = /kakaotalk\/(\S+)/;
    browser.name = 'Kakaotalk';
    browser.version = reg.exec(userAgent)[1];
  }
  return browser;
}


const XLangs = {
  ko: 'ko',
  en: 'en',
  jp: 'ja',
  cn: 'zh',
};

const { language } = settingStore.getState();
let ensureDeviceTokenPromise = null;

function isMissingDeviceError(error) {
  return (
    error?.response?.status === 401 &&
    error?.response?.data?.meta?.systemMessage === 'Not exist device'
  );
}

const deviceStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        appVersion: '1.0.0',
        fcmPushToken: null,
        model: null, //user-agent
        osType: 'WEB',
        osVersion: null, //browser-version
        uuid: null, //자체생성
        deviceToken: null,
        setFcmPushToken: (token) => {
          set({ fcmPushToken: token });
        },
        addDevice: () => {
          const userAgent = window.navigator.userAgent;
          const browserInfo = getClientInfo().version;
          let uuid = get().uuid ? get().uuid : uuidv4();

          console.log('userAgent : ', userAgent);
          console.log('browserInfo : ', browserInfo);
          return authService
            .addDevice({
              appVersion: get().appVersion,
              model: userAgent,
              osType: 'WEB',
              osVersion: browserInfo,
              uuid: uuid,
              languageType: XLangs?.[language],
            })
            .then((res) => {
              set({
                model: userAgent,
                osVersion: browserInfo,
                uuid: res.data.data.uuid,
              });
              return get().authDevice(res.data.data.uuid, 'WEB');
            })
            .catch(() => {
              console.log('Device registration failed');
              return null;
            });
        },
        updateDevice: () => {
          const userAgent = window.navigator.userAgent;
          const browserInfo = getClientInfo().version;
          let uuid = get().uuid ? get().uuid : uuidv4();

          console.log('userAgent : ', userAgent);
          console.log('browserInfo : ', browserInfo);
          authService
            .updateDevice({
              appVersion: get().appVersion,
              fcmPushToken: get().fcmPushToken,
              model: userAgent,
              osType: 'WEB',
              osVersion: browserInfo,
              uuid: uuid,
              languageType: XLangs?.[language],
            })
            .then((res) => {
              set({
                model: userAgent,
                osVersion: browserInfo,
                uuid: res.data.data.uuid,
              });
            })
            .catch(() => {
              console.log('Device update failed');
            });
        },
        authDevice: (deviceUuid, deviceType, rejectOnError = false) => {
          return authService
            .authDevice({
              'device-uuid': deviceUuid,
              'device-type': deviceType,
              'business-type': 'HOTEL',
            })
            .then((res) => {
              set({ deviceToken: res.data.token });
              return res.data.token;
            })
            .catch((e) => {
              if (rejectOnError) return Promise.reject(e);
              console.log('Device authentication failed');
              return null;
            });
        },
        ensureDeviceToken: () => {
          const currentToken = get().deviceToken;
          if (!isJwtExpired(currentToken)) {
            return Promise.resolve(currentToken);
          }
          if (ensureDeviceTokenPromise) return ensureDeviceTokenPromise;

          const request = get().uuid
            ? get().authDevice(get().uuid, 'WEB', true).catch((error) => {
                if (!isMissingDeviceError(error)) return null;
                set({ uuid: null, deviceToken: null });
                return get().addDevice();
              })
            : get().addDevice();
          ensureDeviceTokenPromise = Promise.resolve(request)
            .catch(() => null)
            .finally(() => {
              ensureDeviceTokenPromise = null;
            });
          return ensureDeviceTokenPromise;
        },
      }),
      { name: DEVICE_STORAGE_KEY, version: 0 },
    ),
  ),
);
const debug = false;
deviceStore.subscribe(
  (state) => state.accessToken,
  (deviceToken) => {
    debug && console.log('deviceToken has been changed: ', deviceToken);
  },
);
export default deviceStore;
